import instance from "./index.js";

// 录入试用订单
export const addOfficialTrialOrders = params => {
  return instance.post(
    "/front/official/trial/orders/addOfficialTrialOrders",
    params
  );
};

// 经销商申请
export const apply = params => {
  return instance.post("/distributor/apply", params);
};
